<template>
    <div>
        <div style="display:flex; height:50px; align-items: center; background-color: var(--color-main); position:relative;">
            <div v-if="is_left_area_custom" style="font-size: 20px; width:50px;">
                <slot name="left_area"></slot>
            </div>
            <div v-else-if="isShowBackBtn" style="font-size: 20px; width:50px;" @click="closeModal">
                <div style="width:38px; padding:0px 10px;">
                    <img :src="require('@/assets/img/back_btn.png')" style="width:9px;">
                    <!--<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><path d="M9.4 233.4c-12.5 12.5-12.5 32.8 0 45.3l160 160c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L109.2 288 416 288c17.7 0 32-14.3 32-32s-14.3-32-32-32l-306.7 0L214.6 118.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-160 160z"/></svg>-->
                </div>
            </div>
            <div v-else style="font-size: 20px; width:50px;"></div>
            <div style="flex:1;text-align:center; font-size:20px; font-weight:bold; color:white;">{{title}}</div>
            <div style="width:60px; display:grid;place-items: center;">
                <div v-if="is_show_logout_btn" style="width:20px;" @click="logout">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path d="M377.9 105.9L500.7 228.7c7.2 7.2 11.3 17.1 11.3 27.3s-4.1 20.1-11.3 27.3L377.9 406.1c-6.4 6.4-15 9.9-24 9.9c-18.7 0-33.9-15.2-33.9-33.9l0-62.1-128 0c-17.7 0-32-14.3-32-32l0-64c0-17.7 14.3-32 32-32l128 0 0-62.1c0-18.7 15.2-33.9 33.9-33.9c9 0 17.6 3.6 24 9.9zM160 96L96 96c-17.7 0-32 14.3-32 32l0 256c0 17.7 14.3 32 32 32l64 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-64 0c-53 0-96-43-96-96L0 128C0 75 43 32 96 32l64 0c17.7 0 32 14.3 32 32s-14.3 32-32 32z"/></svg>
                </div>
            </div>
            <div v-if="is_show_absolute_area" style="position:absolute; top:0px; left:0px; width:100%; height:100%; ">
                <slot name="absolute_area"></slot>
            </div>
        </div>
        <div style="height:15px; background-color: var(--color-main); overflow:hidden;">
            <div style="height:30px; border-radius:15px; background-color: white;"></div>
        </div>
    </div>
</template>

<script>
    import ResponseCode from "../../ResponseCode";

    export default {
        name: "ModalHeader",
        props : {
            title : {
                type : String,
                default : ''
            },
            isShowBackBtn : {
                type : Boolean,
                default : true
            },
            closeAction : {
                type : Function,
                default : null
            },
            is_show_logout_btn : {
                type : Boolean,
                default : false
            },
            is_left_area_custom : {
                type : Boolean,
                default : false
            },
            is_show_absolute_area : {
                type : Boolean,
                default : false
            }
        },
        methods : {
            closeModal(){
                if(this.closeAction) {
                    this.closeAction();
                } else {
                    this.$GlobalStore.closeLastModal();
                }
            },
            async logout(){
                this.$GlobalStore.showConfirm('정말로 로그아웃 하시겠습니까?', async () => {
                    const res = await this.$Axios.post('/api/logout');
                    if(res.data.code === ResponseCode.SUCCESS){
                        this.$GlobalRouter.push('/view/login?time=' + new Date().getTime());
                    }else if(res.data.code === ResponseCode.FAIL){
                        this.$GlobalStore.showAlert(res.data.msg);
                    }
                }, '확인', '취소', async () => {})
            }
        }
    }
</script>

<style scoped>

</style>